import { useSelector as useReduxSelector, TypedUseSelectorHook } from 'react-redux';
import { RootState } from 'state/store';

// Default Typed useSelector
const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
export default useSelector;